import { PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { constantCase } from 'change-case';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var TranslateDeadlineStatusPipe = /** @class */ (function () {
    function TranslateDeadlineStatusPipe(translateService, fuseTranslationLoaderService) {
        this.translateService = translateService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    TranslateDeadlineStatusPipe.prototype.transform = function (type) {
        if (!type) {
            return null;
        }
        return this.translateService.instant("MAINTENANCE_DEADLINE_STATUS." + constantCase(type));
    };
    return TranslateDeadlineStatusPipe;
}());
export { TranslateDeadlineStatusPipe };
